import React, { useState } from 'react'

import { SearchOutlined, ThumbDown, ThumbUp } from '@mui/icons-material'
import StopIcon from '@mui/icons-material/Stop'

import ManualAnalysisForm from 'components/ManualAnalysisForm'
import { Expansible } from 'components/Expansible'
import BuildCompanyData from 'components/ExpandedInfo/BgcExpansible/BuildCompanyData'
import BuildProcesses from 'components/ExpandedInfo/BgcExpansible/BuildProcesses'
import BuildFamilyRelations from 'components/ExpandedInfo/BgcExpansible/BuildFamilyRelations'
import Colors from 'utils/Colors'

import ReferenceCheck from 'components/ExpandedInfo/ReferenceCheck'
import Typography from '@mui/material/Typography'
import { SUSPENDED_ANALYSIS_MESSAGE, USER_ROLE } from 'utils/constants/application'
import { Button } from 'components'
import { useSelector } from 'react-redux'
import { Divider } from '@mui/material'
import BuildScoreRelated from '../BuildScoreRelated'

import { IconLabel, TitleContainer } from '../styles'
import DisplayJustificative from './DisplayJustificative'
import CommentsSection from './CommentsSection'

const BuildListItem = (props) => {
  const { issue, checkType, open, onDataChanged } = props
  const userRole = useSelector(state => state.auth.user_role)
  const [review, setReview] = useState(issue)
  const [showEditButton, setShowEditButton] = useState(review.waiting_clarification && userRole !== USER_ROLE.adminReadOnly)


  const updateReview = (newValue) => {
    setReview(newValue)
    onDataChanged?.()
    
    if (newValue.waiting_clarification && userRole !== USER_ROLE.adminReadOnly) {
      setShowEditButton(true)
    }
  }

  const buildLabel = (status, color) => {
    return (
      <IconLabel style={{ backgroundColor: color, color: '#FFFFFF' }}>
        {status === 'APPROVED' && (
          <React.Fragment>
            <ThumbUp fontSize="inherit" />
            <span>Aprovado</span>
          </React.Fragment>
        )}
        {status === 'REPROVED' && (
          <React.Fragment>
            <ThumbDown fontSize="inherit" />
            <span>Reprovado</span>
          </React.Fragment>
        )}
        {status === 'WAITING_DECISION' && (
          <React.Fragment>
            <SearchOutlined fontSize="small" />
            <span>Pendente</span>
          </React.Fragment>
        )}
        {status === 'SUSPENDED' && (
          <React.Fragment>
            <StopIcon fontSize="small" />
            <span>Suspensa</span>
          </React.Fragment>
        )}
      </IconLabel>
    )
  }

  const getTitle = (title, status) => {
    const colors = {
      APPROVED: Colors.green,
      REPROVED: Colors.red,
      SUSPENDED: Colors.yellow,
      WAITING_DECISION: Colors.loginLigthenPrimaryColor,
    }

    return (
      <TitleContainer style={{ color: colors[status] }}>
        <span>{title}</span>
        {buildLabel(status, colors[status])}
      </TitleContainer>
    )
  }

  const showSuspendedReviewMessage = () => (
    <Typography variant="h7" style={{ color: Colors.orange, fontSize: '1.6rem' }}>
      {SUSPENDED_ANALYSIS_MESSAGE}
    </Typography>
  )
  return (
    <Expansible
      open={open || false}
      title={getTitle(review.review_type === 'score_board' ? 'SCORE DE RISCO' : review.issue, review.decision)}
    >
      <div className="issue-container">
        {review.decision === 'SUSPENDED' && showSuspendedReviewMessage()}
        {review.review_type === 'company_data' && <BuildCompanyData companyData={review.company_data} />}
        {review.review_type === 'process_data' && <BuildProcesses processData={review.process_data} />}
        {review.review_type === 'score_board' && (
          <BuildScoreRelated scoreBoardData={review.score_board} isInDenyList={false} />
        )}  
        {review.review_type === 'family_relation_data' && (
          <BuildFamilyRelations familyRelationsData={review.family_relation} />
        )}
        {review.review_type === 'financial_pendings_data' && <ReferenceCheck rfcData={review} />}
        
        {(review.decision === 'WAITING_DECISION' && !showEditButton) && (
            <ManualAnalysisForm
              issueId={review.uuid}
              role={review.user_role}
              checkType={checkType}
              updateReview={updateReview}
              isWaitingClarification={review.waiting_clarification}
            />
          )}
        
        {(['APPROVED', 'REPROVED'].includes(review.decision) ||  review.waiting_clarification) && (
          <DisplayJustificative
            status={review?.decision}
            decisionTimestamp={review?.decision_timestamp}
            reviewerComment={review?.reviewer_comment}
            reviewer={review?.reviewer?.name}
            isWaitingClarification={review?.waiting_clarification}
            waitingClarificationTimestamp={review?.waiting_clarification_timestamp}
          />
        )}

        {(showEditButton && review.waiting_clarification && review.decision === 'WAITING_DECISION') && (
          <div style={{ marginTop: 20 }}>
            <Button onClick={() => setShowEditButton(false)}>Revisar em definitivo</Button>
          </div>
          )
          }

        
        <div style={{ marginTop: 20 }}>
          
          <Divider style={{ marginBottom: 20 }} />

          <CommentsSection checkType={checkType} review={issue} />
        </div>
      </div>
    </Expansible>
  )
}

export default BuildListItem
